var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.686677 6.95292C0.0724332 6.95292 -0.234688 7.73635 0.212034 8.18832L3.53453 11.774C3.78581 12.0753 4.20462 12.0753 4.48382 11.774L7.80632 8.18832C8.22512 7.73635 7.918 6.95292 7.33167 6.95292H0.686677ZM7.80632 3.78908L4.48382 0.20339C4.20462 -0.0677966 3.78581 -0.0677966 3.53453 0.20339L0.212034 3.78908C-0.234688 4.27119 0.0724332 5.02448 0.686677 5.02448H7.33167C7.918 5.02448 8.22512 4.27119 7.80632 3.78908Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpDown);
export default __webpack_public_path__ + "static/media/sort-up-down.9ef9864b.svg";
export { ForwardRef as ReactComponent };